import React from 'react';
import Select from 'corp/components/UI/Select';
import { fetchWorkerSourceOptions, WorkerSource } from 'corp/hooks/useWorkerSource';

const SelectWorkerSource = (props: $FIXME) => {
  const [workerSourceOptions, setWorkerSourceOptions] = React.useState<WorkerSource[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchWorkerSources = async () => {
      try {
        const options = await fetchWorkerSourceOptions({
          filterOutCrowd: props.includeNoWorkerSource, // If we're including no worker source, we should filter out crowd
        });
        setWorkerSourceOptions(options);
      } catch (err) {
        // Error is already handled in the API function
      } finally {
        setLoading(false);
      }
    };

    fetchWorkerSources();
  }, [props.includeNoWorkerSource]);

  if (loading) {
    return <Select {...props} options={[]} placeholder="Loading worker sources..." disabled />;
  }

  return (
    <Select
      {...props}
      options={workerSourceOptions.map(source => ({ value: source.source, label: source.name }))}
      placeholder="Select worker source"
    />
  );
};

export default SelectWorkerSource;
